import React, { useState } from 'react'
import birdLogo from '../../../public/birdid.svg';

function enableLoading() {
  disableLoading();

  let divSpinner = document.createElement('div');
  divSpinner.setAttribute('id', 'spinner-displayer-id');
  divSpinner.classList.add('spinner-displayer');
  divSpinner.classList.add('loading');

  document.body.append(divSpinner);
}

function disableLoading() {
  if (document.getElementById("spinner-displayer-id"))
    document.getElementById("spinner-displayer-id").remove();
  if (document.getElementById("spinner-displayer-id"))
    document.getElementById("spinner-displayer-id").outerHTML = "";
}

function Authentication(props) {
  const [isWrongPwd, setWrongPwd] = useState(false)

  const fnAuthenticate = (params) => async (e) => {
    e.preventDefault()

    let data = {}
    for (const pair of new FormData(e.target)) {
      data[`${pair[0]}`] = pair[1];
    }

    const token = document.querySelector(
      'input[name="authenticity_token"]'
    ).value

    enableLoading();

    fetch('/signature/authenticate', {
      method: 'POST',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Content-Type': 'application/json',
        'X-CSRF-Token': token,
        Accept: 'application/json',
      },
      body: JSON.stringify(data)
    }).then((response) => {
      disableLoading()
      if (response.status === 200) {
        response.json().then(data => {
          let auth = JSON.stringify({
            token: data.Authorization,
            lifetime: Math.round(Date.now() / 1000) + data.expires_in
          });

          localStorage.setItem('access_token', auth);
          props.onClose()
        }).catch(err => {
          setWrongPwd(true);
        })

      } else {
        setWrongPwd(true);
      }

    }).catch(err => {
      disableLoading()
      setWrongPwd(true);
    })
  }

  const faqUrl = window.location.origin + '/faq.html';

  const accessToken = localStorage.getItem('access_token');
  if (!accessToken) {
    return (
      <div className="modal display-block">
        <section className="modal-main" >

          <a
            className="close-forward-options"
            href="#"
            aria-label="Fechar"
            onClick={(e) => {
              e.preventDefault()
              props.onClose()
            }}
          >
            ×
          </a>

          <img src={birdLogo} width={120} alt="Logo Birdid"/>
          <br/>
          <span style={{ fontSize: '25px', color: "#3b3a3a" }}>Assinar Digitalmente</span>
          <br />
          <p className="color-title">Para autenticar, abra seu aplicativo BirdID e visualize seu código OTP (código de 6 digítos)</p>

          <form onSubmit={fnAuthenticate('email')}>
            <div className="channel color-title ">
              <i className="fa fa-user" aria-hidden="true"></i>
              <span>CPF/CNPJ</span>
            </div>
            <div className="channel-fields">
              <input
                required
                autoComplete="off"
                type="tel"
                name="username"
              />
            </div>

            <br />

            <div className="channel color-title ">
              <i className="fa fa-lock" aria-hidden="true"></i>
              <span>Código OTP (6 dígitos)</span>
            </div>
            <div className="channel-fields">
              <input
                required
                autoComplete="off"
                type="tel"
                name="password"
              />
            </div>
            {isWrongPwd && <h5 style={{ textAlign: 'right' }}>Usuário e/ou senha incorretos.</h5>}
            <br />

            <span className="color-title">Assine suas receitas pela Formulapp e envie apenas a via digital por e-mail ou Whatsapp web, sem precisar imprimir.</span>
            <p><a href={faqUrl} target="_blank" style={{ color: "#4747e8" }}>Como eu assino digitalmente pela FormulApp ?</a></p>

            <button type="submit" style={{ float: "right" }}>
              Autenticar
            </button>
          </form>
        </section>
      </div>
    );

  } else {
    return (<></>);
  }
}

function ModalNotification(props = {}) {
  let message = props.message || 'Falha ao assinar. Por favor, tente novamente';

  return (
    <div className="modal display-block">
      <section className="modal-notification" >

        <a
          className="close-forward-options"
          href="#"
          aria-label="Fechar"
          onClick={(e) => {
            e.preventDefault()
            props.onClose()
          }}
        >
          ×
        </a>
        <div style={{ backgroundColor: '#c96cd5', height: "50px" }}></div>

        <div style={{ padding: "1rem 2rem" }}>
          <p className="color-title">{message}</p>
        </div>

      </section>
    </div>
  );
}
export default function DigitalSignature(props = {}) {

  const [isSigned, setIsSigned] = useState(false)
  const [submitted, setSubmitted] = useState(false)
  const [isAuthenticated, setIsAuthenticated] = useState(false)

  const [message, setMessage] = useState({ message: '' });

  function sign(accessToken) {

    const token = document.querySelector(
      'input[name="authenticity_token"]'
    ).value

    let data = {
      accessToken,
      id: props.id
    }

    enableLoading();
    fetch('/signature/sign', {
      method: 'POST',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Content-Type': 'application/json',
        'X-CSRF-Token': token,
        Accept: 'application/json',
      },
      body: JSON.stringify(data)
    }).then((response) => {
      disableLoading();

      if (response.status === 200) {
        setMessage({ message: "Parabéns. Receita assinada com sucesso." });
        setIsSigned(true);
      } else {
        response.json().then(data => {
          setMessage({ message: data.message || 'Falha ao assinar. Por favor, tente novamente. ' });
          setIsSigned(true);

        }).catch(err => {
          setMessage({ message: 'Falha ao assinar. Por favor, tente novamente. ' });
          setIsSigned(true);
        })
      }

    }).catch(err => {
      disableLoading();

      setMessage({ message: 'Falha ao assinar. Por favor, tente novamente' });
      setIsSigned(true);
    });

  }

  const singAfterAuthenticated = () => {
    setSubmitted(false);

    if (localStorage.getItem('access_token')) {
      let auth = JSON.parse(localStorage.getItem('access_token'));

      if (auth.lifetime < Math.round(Date.now() / 1000)) {
        localStorage.removeItem('access_token');
        setIsAuthenticated(false)
      } else {
        setIsAuthenticated(true)
        sign(auth.token);
      }
    }
  }

  return (
    <>
      <a
        href="#" onClick={(e) => {
          e.preventDefault()

          setSubmitted(true)
          if (localStorage.getItem('access_token')) {
            let auth = JSON.parse(localStorage.getItem('access_token'));

            if (auth.lifetime < Math.round(Date.now() / 1000)) {
              localStorage.removeItem('access_token');
              setIsAuthenticated(false)
            } else {
              setIsAuthenticated(true)
              sign(auth.token);
            }
          } else {
            setIsAuthenticated(false)
          }
        }}
      >
        <i className="fa fa-pencil"> </i><span>Assinar</span>
      </a>

      {submitted && !isAuthenticated && (<Authentication {...props} onClose={singAfterAuthenticated} />)}

      {isSigned && (<ModalNotification {...message} onClose={() => document.location.reload(false)} />)}
    </>
  )

}
